import { combineReducers } from 'redux';
import activateChannelPin from './activateChannelPin.reducer';
import activateControlPin from './activateControlPin.reducer';
import blockChannel from './blockChannel.reducer';
import checkControlPin from './checkControlPin.reducer';
import remindControlPin from './remindControlPin.reducer';
import statusControlPin from './statusControlPin.reducer';
import unblockChannel from './unblockChannel.reducer';
import temporarilyUnlocked from './temporarilyUnlockContent.reducer';

export default combineReducers({
  activateChannelPin,
  activateControlPin,
  blockChannel,
  checkControlPin,
  remindControlPin,
  statusControlPin,
  unblockChannel,
  temporarilyUnlocked,
});
